(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 87314:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(64788);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 64788:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(94776);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../packages/auth/index.ts + 135 modules
var auth = __webpack_require__(6454);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ./constants/routes.ts
var routes = __webpack_require__(57210);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 3 modules
var emotion_styled_browser_esm = __webpack_require__(47951);
// EXTERNAL MODULE: ../../node_modules/@chakra-ui/system/dist/chunk-3LE6AY5Q.mjs + 2 modules
var chunk_3LE6AY5Q = __webpack_require__(59385);
// EXTERNAL MODULE: ../../node_modules/@chakra-ui/system/dist/chunk-QEVFQ4EU.mjs
var chunk_QEVFQ4EU = __webpack_require__(17107);
;// CONCATENATED MODULE: ../../node_modules/@chakra-ui/layout/dist/chunk-3V5HNFOM.mjs
// src/center.tsx


var Center = (0,chunk_3LE6AY5Q/* chakra */.m)("div", {
  baseStyle: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  }
});
Center.displayName = "Center";
var centerStyles = {
  horizontal: {
    insetStart: "50%",
    transform: "translateX(-50%)"
  },
  vertical: {
    top: "50%",
    transform: "translateY(-50%)"
  },
  both: {
    insetStart: "50%",
    top: "50%",
    transform: "translate(-50%, -50%)"
  }
};
var AbsoluteCenter = (0,chunk_QEVFQ4EU/* forwardRef */.G)(
  function AbsoluteCenter2(props, ref) {
    const { axis = "both", ...rest } = props;
    return /* @__PURE__ */ (0,jsx_runtime.jsx)(
      chunk_3LE6AY5Q/* chakra.div */.m.div,
      {
        ref,
        __css: centerStyles[axis],
        ...rest,
        position: "absolute"
      }
    );
  }
);



// EXTERNAL MODULE: ../../node_modules/@chakra-ui/spinner/dist/chunk-NO6MRLPK.mjs
var chunk_NO6MRLPK = __webpack_require__(420);
;// CONCATENATED MODULE: ./pages/index.tsx



function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    height: 100vh;\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}








var Index = function() {
    var userDetails = (0,react.useContext)(auth/* MagicConnectUserContext */.d$).userDetails;
    var router = (0,next_router.useRouter)();
    var logout = (0,auth/* useLogout */.aU)().logout;
    (0,react.useEffect)(function() {
        if ( true && window.Intercom) {
            window.Intercom("update", {
                hide_default_launcher: true
            });
        }
    }, []);
    (0,react.useEffect)(function() {
        var handleFetchArtist = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            if (userDetails === null || userDetails === void 0 ? void 0 : userDetails.wallet_public_address) {
                                if (userDetails.type === "User") {
                                    router.push(routes/* routes.NO_CREATOR */._.NO_CREATOR);
                                } else {
                                    router.push(routes/* routes.COLLECTIONS */._.COLLECTIONS);
                                }
                            }
                        case 1:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function handleFetchArtist() {
                return _ref.apply(this, arguments);
            };
        }();
        handleFetchArtist();
    }, [
        userDetails,
        logout,
        router
    ]);
    var StyledContainer = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject());
    if (userDetails === null || userDetails === void 0 ? void 0 : userDetails.wallet_public_address) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Center, {
            minW: "100vh",
            position: "absolute",
            top: "50%",
            w: "full",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_NO6MRLPK/* Spinner */.$, {})
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledContainer, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(auth/* AuthenticationModal */.Xv, {
            alwaysOpened: true,
            showButton: false
        })
    });
};
var __N_SSG = true;
/* harmony default export */ var pages = (Index);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(87314); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);